export const map = {
    components: {
        intro: require('components/intro/intro.desktop'),
        select: require('components/select/select.desktop'),
        scrollUp: require('components/scroll-up/scroll-up.desktop'),
        tabs: require('components/tabs/tabs.desktop'),
        footer: require('components/footer/footer.desktop'),
        officesCard: require('components/offices-card/offices-card.desktop'),
        relatedPages: require('components/related-pages/related-pages.desktop'),
        newsHeadline: require('components/news-headline/news-headline.desktop'),
        blockAuthor: require('components/block-author/block-author.desktop'),
        jobRibbon: require('components/job-ribbon/job-ribbon.desktop'),
        jobsIntroduction: require('components/jobs-introduction/jobs-introduction.desktop'),
        keyWords: require('components/key-words/key-words.desktop'),
        referenceDownloads: require('components/reference-downloads/reference-downloads.desktop'),
        referenceDetails: require('components/reference-details/reference-details.desktop'),
        referenceCard: require('components/reference-card/reference-card.desktop'),
        referencesFilters: require('components/references-filters/references-filters.desktop'),
        iconTabulations: require('components/icon-tabulations/icon-tabulations.desktop'),
        blockImage: require('components/block-image/block-image.desktop'),
        slideshow: require('components/slideshow/slideshow.desktop'),
        blockTextImage: require('components/block-text-image/block-text-image.desktop'),
        gridLogo: require('components/grid-logo/grid-logo.desktop'),
        imageTransition: require('components/image-transition/image-transition.desktop'),
        aboutIntroduction: require('components/about-introduction/about-introduction.desktop'),
        instagramFeed: require('components/instagram-feed/instagram-feed.desktop'),
        newsCard: require('components/news-card/news-card.desktop'),
        blockCareer: require('components/block-career/block-career.desktop'),
        blockVideo: require('components/block-video/block-video.desktop'),
        header: require('components/header/header.desktop'),
        menu: require('components/menu/menu.desktop'),
        historySlider: require('components/history-slider/history-slider.desktop'),
        blockMap: require('components/block-map/block-map.desktop'),
        interactiveMap: require('components/interactive-map/interactive-map.desktop'),
        businessLinesList: require('components/business-lines-list/business-lines-list.desktop')
    },
    pages: {
        master: { index: require('pages/master/master-index.desktop') },
        about: { index: require('pages/about/about-index.desktop') },
        homepage: {
            index: require('pages/homepage/homepage-index.desktop')
        },
        expertises: {
            index: require('pages/expertises/expertises-index.desktop')
        },
        news: {
            list: require('pages/news/list/news-list.desktop'),
            entry: require('pages/news/entry/news-entry.desktop')
        },
        references: {
            list: require('pages/references/list/references-list.desktop'),
            entry: require('pages/references/entry/references-entry.desktop')
        },
        business: {
            service: require('pages/business/service/business-service.desktop'),
            products: require('pages/business/products/business-products.desktop')
        },
        contact: {
            index: require('pages/contact/contact-index.desktop')
        },
        static: {
            index: require('pages/static/static-index.desktop')
        },
        unsupported: {
            index: require('pages/browser-not-supported/browser-not-supported-index.desktop')
        },
        error: {
            index: require('pages/error/error-index.desktop')
        },
        career: {
            about: require('pages/career/about/career-about.desktop'),
            jobs: require('pages/career/jobs/career-jobs.desktop')
        },
        history: {
            index: require('pages/history/history-index.desktop'),
        },
        businesslines: {
            entry: require('pages/business-lines/entry/business-lines-entry.desktop'),
        },
    }
};



// WEBPACK FOOTER //
// ./src/js/map/map.desktop.js